















































































import axios from 'axios';
import EventBus from '../../../eventBus';

import { get, uniq, orderBy } from 'lodash';
import { isValid, startOfWeek, endOfWeek, format } from 'date-fns';
import CoTable from '../../Molecules/co-table/CoTable.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoSelect from '../../Molecules/co-select/CoSelect.vue';
import CoDownloadAsCsv from '../co-download-as-csv/CoDownloadAsCsv.vue';
import CoDate from '../../Molecules/co-date/CoDate.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoDateRangePicker from '@/components/Atoms/co-date-range-picker/CoDateRangePicker.vue';

export default {
    name: 'CoBookingStatistics',
    components: {
        CoTable,
        CoIcon,
        CoDownloadAsCsv,
        CoSelect,
        CoDate,
        CoDateRangePicker,
        CoLink,
    },
    data() {
        return {
            fields: [
                {
                    key: 'Resource.Name',
                    title: this.$t('labels.resourcename'),
                    sortable: true,
                },
                {
                    key: 'FromDate',
                    title: this.$t('labels.bookingstart'),
                    sortable: true,
                },
                {
                    key: 'Title',
                    title: this.$t('labels.title'),
                    sortable: true,
                },
                {
                    key: 'Duration',
                    title: `${this.$t('labels.duration')} (${this.$tc('units.hours', 2)})`,
                    sortable: true,
                    sum: true,
                    class: 'text-right',
                },
                {
                    key: 'PriceNet',
                    title: `${this.$t('labels.price')} (${this.$t('labels.pricenet')})`,
                    sortable: true,
                    sum: true,
                    class: 'text-right',
                },
                {
                    key: 'CreatedDate',
                    title: this.$t('labels.created'),
                    sortable: true,
                },
                {
                    key: 'User.Profile.Name',
                    title: this.$t('labels.user'),
                    sortable: true,
                },
            ],

            bookings: [],
            bookingsLoading: false,
            bookingsError: false,

            resourcesList: [],
            resourcesLoading: false,
            resource: null,
            dateRange: {
                startDate: startOfWeek(new Date()),
                endDate: endOfWeek(new Date()),
            },
        };
    },
    async mounted() {
        this.bookingsLoading = true;
        //fetch resources
        await this.listResources();
        //fetch bookings
        this.listBookings();
    },
    watch: {
        dateRange: {
            handler() {
                this.listBookings();
            },
            deep: true,
        },
        resource() {
            this.listBookings();
        },
    },
    methods: {
        get,
        listResources() {
            this.resourcesLoading = true;
            var resources = [];

            return new Promise((resolve, reject) => {
                axios({
                    method: 'GET',
                    url: '/admin/booking/resource/list',
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        // Keep an empty first-use response from being treated as a failed request.
                        const bookingResources =
                            response.data && Array.isArray(response.data.Resources) ? response.data.Resources : [];
                        resources = bookingResources.map((item) => ({
                            Name: item.Name,
                            Value: item.ID,
                        }));
                        resources.sort((a, b) => a.Name.localeCompare(b.Name));
                        //always add the default value to the select as first item
                        this.resourcesList = [
                            {
                                Name: this.$t('labels.allresources'),
                                Value: null,
                            },
                        ].concat(resources);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        resolve(true);
                        this.resourcesLoading = false;
                    });
            });
        },
        listBookings() {
            this.bookingsLoading = true;
            this.bookingsError = false;

            let start = format(this.dateRange?.startDate, 't');
            let end = format(this.dateRange?.endDate, 't');

            var url = `/admin/booking/list?start=${start}&end=${end}`;

            if (this.resource?.Value) {
                url = `/admin/booking/list/${this.resource?.Value}/${start}/${end}`;
            }
            axios({
                method: 'GET',
                url: url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (response && response.data && response.data.Bookings) {
                        //fetch user info for each booking
                        let userIDs = [];
                        response.data.Bookings.map((item) => {
                            if (item.UserID) userIDs.push(item.UserID);
                        });
                        let userData =
                            userIDs.length > 0
                                ? await this.$store.dispatch('listUsersByIDs', {
                                      ids: { IDS: uniq(userIDs).map((id) => ({ ID: id })) },
                                  })
                                : { Users: [] };
                        //map the booking data
                        let bookings = response.data.Bookings.map((item) => {
                            if (item.Price && item.Price.PriceInCentsNet) {
                                item.PriceNet = (item.Price.PriceInCentsNet / 100).toFixed(2);
                                item.PriceNet = item.PriceNet ? item.PriceNet : 0;
                            } else {
                                item.PriceNet = item.PriceInCentsNet ? (item.PriceInCentsNet / 100).toFixed(2) : 0;
                            }
                            item.CreatedDate = isValid(item.CreatedAt * 1000)
                                ? new Date(item.CreatedAt * 1000).toISOString()
                                : null;
                            item.FromDate = isValid(item.Start * 1000)
                                ? new Date(item.Start * 1000).toISOString()
                                : null;
                            item.ToDate = isValid(item.End * 1000) ? new Date(item.End * 1000).toISOString() : null;
                            item.Duration = item.Start && item.End ? (item.End - item.Start) / 60 / 60 : null;
                            item.User = userData.Users.find((user) => user.ID === item.UserID);
                            return item;
                        });
                        this.bookings = orderBy(bookings, ['Start'], ['asc']);
                    } else {
                        this.bookings = [];
                    }
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: get(error, 'response.data.message', this.$t('errors.failedGeneric')),
                        Details: error,
                    });
                    this.bookings = [];
                    this.bookingsError = true;
                })
                .finally(() => {
                    this.bookingsLoading = false;
                });
        },
    },
};
